import React, { Component } from "react";
import axiosVirdioT from '../../utils/axios';
var axiosVirdio;

class PersonalBest extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			currentUserData: JSON.parse(localStorage.getItem('userData')),
		}
	}
 
	componentDidMount(){
		axiosVirdio = new axiosVirdioT(this.props);
		
		//this.getLeaderboardValues();
	}
	
	getLeaderboardValues=()=>{
		axiosVirdio.post(process.env.REACT_APP_API_URL +'/api/v1/session/getLeaderboardValues', {userId: this.state.currentUserData.id }).then(res => {
			var mainResponse = res.data.responseData;
			console.log('mainResponse',mainResponse);
			this.setState({leaderboardValues: mainResponse});
			
			}).catch(err =>{ 
			
		});   
	}
	
	render() {
		return (
			<div className="personal_b_holder">
				<div className="personal_b_content">
					<img src="./images/boxing.png" alt=""/>
					<div className="personal_b_txt_holder">
						<div className="personal_b_record">Personal Record</div>
						<div className="personal_b_ppm">0 reps per minute</div>
					</div>
				</div>
			</div>		
	)}
}

export default PersonalBest
